export default "__VITE_ASSET__DFfndIuH__"